import React, { useState, useEffect } from 'react'
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'
import search from '../../../Assets/home2/search.svg'
import icon6 from '../../../Assets/crane/icon6.svg'
import icon7 from '../../../Assets/crane/icon7.svg'
import icon8 from '../../../Assets/crane/icon8.svg'
import icon9 from '../../../Assets/crane/icon9.svg'
import icon10 from '../../../Assets/crane/icon10.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'

import icon11 from '../../../Assets/crane/icon11.svg'
import img1 from '../../../Assets/add/img1.png'
import img3 from '../../../Assets/add/img3.png'
import img2 from '../../../Assets/add/img2.png'
import img6 from '../../../Assets/add/img6.png'
import img7 from '../../../Assets/add/img7.png'
import icon2 from '../../../Assets/add/icon2.svg'
import icon1 from '../../../Assets/add/icon1.svg'
import icon3 from '../../../Assets/add/icon3.svg'

import axios from 'axios';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import NotInterestedIcon from '@mui/icons-material/NotInterested';

// import '../FirstPage.css'
import '../FirstPageDesigns/FirstPage.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import casefiled from '../../../Assets/casefiled.png'
import telephonecall from '../../../Assets/telephonecall.png'
import checksuccess from '../../../Assets/checksuccess.png'
import crossUser from '../../../Assets/crossUser.png'
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import SuccessIcon from '../../../Component/Vendors/FirstAppearComponent/CaseFirstCard/SuccessIcon.jsx';
import filterUser from '../../../Assets/filterUser.png'
import LookingForAccptance from '../Registration/LookingForAcceptance.jsx';
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import { useWebSocket } from '../../../context/WebSocketContext.jsx' // i am edited websocket;

import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import SignalWifi4BarIcon from '@mui/icons-material/SignalWifi4Bar';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PinDropIcon from '@mui/icons-material/PinDrop';
import { MapContainer, TileLayer } from 'react-leaflet';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import GarageIcon from '@mui/icons-material/Garage';
import PersonIcon from '@mui/icons-material/Person';
import { Alert } from '@mui/material';
import CraneFirstPage from './CraneFirstPage.jsx'


function QuotationUpdate({ vehicleNumber }) {
    const [currentStage, setCurrentStage] = useState([]); // Example stage
    const currentService = localStorage.getItem("currentService")
    const { messages } = useWebSocket();
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);

    console.log("currentStage123", `${currentService}Details`)
    const [currentStage1, setCurrentStage1] = useState(2); // Example stage
    const [isImageContainerVisible, setIsImageContainerVisible] = useState(false);
    const [isCancelContainerVisible, setIsCancelContainerVisible] = useState(false);

    const [reasonsForDrop, setReasonsForDrop] = useState(false);


    const [alreadyCancelled, setAlreadyCancelled] = useState(false);
    const [cancelled, setCancelled] = useState(false);


    console.log("reasonForDrop", reasonsForDrop)


    const [caseDetails, setCaseDetails] = useState(false);
    const [currentItem, setCurrentItem] = useState({});
    console.log("currentItme", currentItem)


    const [data, setData] = useState([]);
    console.log("DATAishere", data)
    const [dummyData, setDummyData] = useState([]);
    const [filter, setFilter] = useState('')
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [doneFetching, setDoneFetching] = useState(false)
    console.log("DATA HERE", data)
    const [currentItems, setCurrentItems] = useState(data);
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");


    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const getFilteredData = (filter) => {
        console.log("data is here");
        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));




        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        console.log("todayDate", todayDate)
        console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < dummyData.length; i++) {
            let getTime = dummyData[i]?.[`${currentService}Details`]?.systemDate.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(dummyData[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    console.log("Match found within last year:", dummyData[i]);
                    filteredData.push(dummyData[i]);
                }
            }

        }
        if (filter === 'newest') {
            console.log("Sorting by newest to oldest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...dummyData]);
        } else if (filter === 'oldest') {
            console.log("Sorting by oldest to newest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...dummyData]);
        }
        else {
            setData(filteredData)
        }
    };

    const settingFilter = (filter) => {
        console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }


    const reasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind"
    ];

    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedReasons([...selectedReasons, reason]);
        }
    };


    const [reasonsSecForDrop, setReasonsSecForDrop] = useState(false);
    const [isCancelSecondaryContainerVisible, setIsCancelSecondaryContainerVisible] = useState(false);
    const [selectedSecReasons, setSelectedSecReasons] = useState([]);
    const [otherSecReason, setOtherSecReason] = useState("");
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });

    const secReasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind", 'charging too much'
    ];

    const handleSelectSecReason = (reason) => {
        if (selectedSecReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedSecReasons(selectedSecReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedSecReasons([...selectedSecReasons, reason]);
        }
    };

    const cancelingSecOrder = async (currentItem) => {
        try {
            const reasons = [...selectedSecReasons, otherSecReason].filter(Boolean);
            if (reasons.length === 0) {
                return setAlertInfo({ show: true, message: 'Select Respective Reason', severity: 'error' });
            }
            console.log(`${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderSecondaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}/${currentItem?.[`${currentService}Details`][`${currentService}`]}`)
            const response = await axios({
                method: "PUT",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderSecondaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}/${currentItem[`${currentService}Details`][`${currentService}`]}/${currentItem?.[`${currentService}Details`].vehicleNo}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    cancleOrderReason: [...selectedSecReasons, otherSecReason]
                }
            });

            if (response.data.status === true) {
                setIsCancelSecondaryContainerVisible(false);
                setReasonsSecForDrop(false);
                setIsImageContainerVisible(false)
                setCurrentItem({})
                getData()
            } else {
                setAlreadyCancelled(true);
            }
        } catch (error) {
            console.error("Error canceling order:", error);
        }
    };

    const navigate = useNavigate()


    // Array of stages
    // const stages = ["assigned", "accepted & moved","reached"];
    const stages = [
        { label: "Filed", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/casefiled.png' },
        { label: "Connecting", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/telephonecall.png' },
        { label: "Assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon10.svg' },
    ];

    useEffect(() => {
        setDoneFetching(false)
        if (messages.length > 0) {
            // Filter out all messages that are NOT for 'quotation-updates-crane'
            const remainingMessages = messages.filter((message) => message.forPage !== 'quotation-updates-crane');

            // Flash the messages before removing
            messages.forEach((message) => {
                console.log("messages123", message);
                if (message.forPage === 'quotation-updates-crane') {
                    if (message.message === "vendor-not-found") {
                        setAlertMessage("Currently vendor not found. Please try again later...");
                        setAlertType("danger");
                    } else {
                        getData();
                    }
                }
            });

            // ✅ Remove all messages for 'quotation-updates-crane'
            messages.length = 0;
            messages.push(...remainingMessages);
        }


        console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
        getData();
    }, [token, userId, navigate, currentService, messages]);

    const getData = async (e) => {
        console.log("userid", userId);
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/${currentService}/not-completed`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.data.message === "No accident vehicle data found.") {
            setDoneFetching(true)
            setData([])
        }
        else {
            console.log("responsjdlfjskldfgjlse123421", response.data.data);
            console.log("data2", response.data.data2);

            let filteredData = response.data.data.filter((info) =>
                !info?.[`${currentService}Details`]?.customerAcceptedVendor && !info?.[`${currentService}Details`]?.closeOrder
            );

            let filteredImportant = filteredData.filter((info) =>
                info?.[`${currentService}Details`]?.connectedVendorFully === 1
            )

            let filteredLessImportant = filteredData.filter((info) =>
                info?.[`${currentService}Details`]?.connectedVendorFully === 0
            )
            filteredData = [...filteredImportant, ...filteredLessImportant]
            console.log('filteredData', filteredData)
            setData(filteredData)
            setDummyData(filteredData)

            console.log("seTDATIOATN", filteredData);

            setCurrentItems(response.data.data);
            setDoneFetching(true)
        }
    };


    const goToMap = (item) => {
        console.log("itemfromgotomap", item)
        console.log("item.accidentLatitude", item.accidentLatitude, "item.accidentLongitude", item.accidentLongitude, "vendorCurrentLatitude", vendorCurrentLatitude, "vendorCurrentLongitude", vendorCurrentLongitude)
        navigate('/map-vendor-distance', {
            state: {
                accidentLatitude: item.accidentLatitude,
                accidentLongitude: item.accidentLongitude,
                vendorLatitude: vendorCurrentLatitude,
                vendorLongitude: vendorCurrentLongitude,
                vehicleNo: item.vehicleNo
            }
        })
    }
    const getStage = (connectedVendorFully) => {
        return connectedVendorFully ? 2 : 1;
    }
    useEffect(() => {
        console.log("I GOT TRIGGERED2 ", currentService)

        if (data.length > 0) {
            console.log("I GOT TRIGGERED2 ", currentService)
            const setUpdatedData = data.map((item) => {
                let gotStage = getStage(item?.[`${currentService}Details`]?.connectedVendorFully)
                return gotStage;
            })
            setCurrentStage(setUpdatedData)
        }
    }, [data])


    const connectCaseDetailsOnly = (item) => {
        console.log("DoDfasdf", item?.[`${currentService}Details`])
        console.log("DoDfasdf", item?.vehicle)

        let gotData = {
            ...item?.[`${currentService}Details`],
            accidentImage1: item?.vehicle?.accidentImage1,
            accidentImage2: item?.vehicle?.accidentImage2,
            accidentImage3: item?.vehicle?.accidentImage3,
            accidentImage4: item?.vehicle?.accidentImage4,
        };
        console.log('gotdata', gotData)
        setCurrentItem(gotData)
        setCaseDetails(true)
    }


    // this can be taken to othe page
    const [comingLink, setComingLink] = useState("");


    const getPaymentLink = async (item) => {
        try {
            console.log('getpayemdafsd', `${process.env.REACT_APP_BACKEND_URL}/api/sendPaymentLinkToCustomer/${userId}/${item[`${currentService}Details`].AccidentVehicleCode}/${item[currentService]}/${item[`${currentService}Details`].vehicleNo}`)
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sendPaymentLinkToCustomer/${userId}/${item[`${currentService}Details`].AccidentVehicleCode}/${item[currentService]}/${item[`${currentService}Details`].vehicleNo}`);
            if (response.data.status === true) {
                let link = response.data.data;
                console.log("link coming", link)
                setComingLink(link)
            }
        } catch (error) {
            console.log("Error from get Vendor Rating", error.message)
        }
    }

    const cancelingOrder = async (currentItem) => {
        try {
            console.log('insoidre', currentItem)
            const reasons = [...selectedReasons, otherReason].filter(Boolean);
            if (reasons.length === 0) {
                return setAlertInfo({ show: true, message: 'Select Respective Reason', severity: 'error' });
                console.log('insoidre1')
            }
            console.log('i am here')
            const response = await axios({
                method: "PUT",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderPrimaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    cancleOrderReason: [...selectedReasons, otherReason]
                }
            });

            if (response.data.status === true) {
                setIsCancelContainerVisible(false);
                setReasonsForDrop(false);
                setCancelled(true)
                getData()
            } else {
                setAlreadyCancelled(true);
            }
        } catch (error) {
            console.error("Error canceling order:", error);
        }
    };

    const getPaymentLinkPage = () => {
        console.log("curretnIte", currentItem)
        console.log("craneishererererwrwer", currentItem?.[`${currentService}Details`].vehicleNo,
            currentItem?.[`${currentService}Details`].AccidentVehicleCode,
            currentItem?.[`${currentService}Details`][`${currentService}`],
            userId,
            `${currentService}`)
        navigate(`${comingLink}`, {
            state: {
                vehicleNo: currentItem?.[`${currentService}Details`].vehicleNo,
                accidentVehicleCode: currentItem?.[`${currentService}Details`].AccidentVehicleCode,
                vendorCode: currentItem?.[`${currentService}Details`][`${currentService}`],
                customerCode: userId,
                vendorType: `${currentService}`,
            }
        })
    }


    // wanna take to the other page

    function haversine(lat1, lon1, lat2, lon2) {
        console.log("accident latitude", lat1)
        console.log("accident longtitude", lon1)
        console.log("vehicle latitiude", lat2)
        console.log("vehicle longtitude", lon2)

        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
    }

    const assignedCaseViewVendor = (item) => {
        setCurrentItem(item)
        setIsImageContainerVisible(true)
        getVendorRating(item?.[`${currentService}Details`].crane)
        console.log('item', item?.[`${currentService}Details`].crane);
        console.log('item.crane', item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude);
        getVendorLocation(item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude)
    }
    const cancleCaseProcedureFunc = (item) => {
        setCurrentItem(item)
        setIsCancelContainerVisible(true)
        setReasonsForDrop(false)
        getVendorRating(item?.[`${currentService}Details`].crane)
        getVendorLocation(item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude)
    }
    const cancleCaseSecondaryProcedureFunc = (item) => {
        console.log('hellow')
        setCurrentItem(item)
        setIsCancelSecondaryContainerVisible(true)
        setReasonsForDrop(false)
        getVendorRating(item?.[`${currentService}Details`].crane)
        getVendorLocation(item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude)
    }
    const [average, setAverage] = useState(0)
    const [distance, setDistance] = useState(0)
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")




    const getVendorRating = async (crane) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${crane}`);
            if (response.data.status === true) {
                let customerRating = response.data.data;
                console.log("coming Customer Rating", customerRating);
                if (customerRating.length !== 0) {
                    // let average = customerRating.reduce((acc, item) => acc + parseInt(item.feedbackRatingCrane), 0);
                    setAverage(average / customerRating.length);
                }
            }
        } catch (error) {
            console.log("Error from get Vendor Rating", error.message)
        }
    }

    const getVendorLocation = async (crane, accidentLatitude, accidentLongitude) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${crane}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                console.log('accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude', accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude)
                setDistance(haversine(accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude))
            }
            else if (response.data.message === "User Not found take Location") {
                console.log("User Not found take Location")
            }
        } catch (error) {
            console.log("error in get Vendor Location", error.message)
        }
    }

    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        if (vehicleNumber && dummyData.length > 0) {
            setSearchValue(vehicleNumber);
            handleSearch(vehicleNumber);
        }
    }, [vehicleNumber, dummyData]);

    useEffect(() => {
        return () => setSearchValue('');
    }, [searchValue]);
    const handleSearch = (inputValue) => {
        // console.log("serachvaue", e.target.value)
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase()
        setSearchValue(value);
        const newRows = dummyData.filter((row) => {
            console.log('row', row)
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly

            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row?.[`${currentService}Details`]?.vehicleNo ?? '').toLowerCase().includes(searchLower);
            const chassisNoValue = (row?.[`${currentService}Details`]?.chassisNo ?? '').toLowerCase().includes(searchLower);

            return vehicleNoValue || chassisNoValue;
        });

        setData(newRows);
    };
    return (
        <>
            {/* <CraneFirstPage/> */}
            <div className='flex md:flex-row flex-col justify-center gap-[30px] bg-white'>
                <CraneSideBar />
                <div className='max-w-[979px] py-[38px] px-[40px] w-full bg-[#EFF9FD] border-[1px] border-[#E7E4FC] rounded-[12px]'>
                    <h6 className="font-[700] font-satoshi text-[30px] text-[#0A0119] m-0 pb-[57px]">Quotation & Updates</h6>

                    {doneFetching && data.length > 0 && (
                        <div>
                            {data.map((item, dataIndex) => (
                                <div
                                    key={dataIndex}
                                    className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] relative px-[20px] ms:px-[40px] pb-[27px] rounded-[12px] my-[20px]"
                                >
                                    {/* Top-right icons */}
                                    <div className="absolute right-[20px] top-[20px] flex gap-[13px]">
                                        <button onClick={() => (window.location.href = 'tel: +91 7800 78 4700')}><img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon6.svg' alt="edit" /></button>
                                        {/* <button><img src={icon7} alt="delete" /></button> */}
                                    </div>

                                    {/* Step indicator */}
                                    {/* <ol className="flex items-center justify-between step-line max-w-[536px] mx-auto w-full md:pt-[30px] pt-[80px]">
          <li className="h-[58px] max-w-[58px] w-full">
            <div className="flex flex-col items-center gap-[6px]">
              <img src={icon8} alt="filled" />
              <p className="m-0 font-[500] font-satoshi text-[18px] text-[#21A6E9]">Filled</p>
            </div>
          </li>
          <li className="h-[58px] max-w-[58px] w-full">
            <div className="flex flex-col items-center gap-[6px]">
              <img src={icon9} alt="connecting" />
              <p className="m-0 font-[500] font-satoshi text-[18px] text-[#B1B1B1]">Connecting</p>
            </div>
          </li>
          <li className="h-[58px] max-w-[58px] w-full">
            <div className="flex flex-col items-center gap-[6px]">
              <img src={icon10} className='h-[58px] w-[58px]' alt="assigned" />
              <p className="m-0 font-[500] font-satoshi text-[18px] text-[#B1B1B1]">Assigned</p>
            </div>
          </li>
        </ol> */}

                                    <div className="flex items-center justify-between step-line max-w-[536px] mx-auto w-full md:pt-[30px] pt-[80px]">
                                        {stages.map((stage, index) => (

                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    position: "relative",
                                                    flex: 1,
                                                }}
                                            >

                                                <div
                                                    style={{
                                                        width: "58px",
                                                        height: "58px",
                                                        borderRadius: "50%",
                                                        // border:'1px solid black',
                                                        backgroundColor: currentStage[dataIndex] == index ? index == 2 ? "rgb(11 219 255)" : "#21A6E9" : "#fffffF",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: currentStage[dataIndex] == index ? "2px solid #4CAF50" : "1px solid black",
                                                        transition: "background-color 0.3s ease",
                                                        zIndex: 1,
                                                        marginTop: "5px"
                                                    }}
                                                >

                                                    <img
                                                        src={stage.img}
                                                        alt={stage.label}
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            opacity: currentStage[dataIndex] <= index ? 1 : 0.5,
                                                        }}
                                                    />
                                                    {index === currentStage[dataIndex] && (
                                                        <div className="loader"></div>
                                                    )}
                                                </div>

                                                <p
                                                    style={{
                                                        marginTop: "5px",
                                                        color: currentStage[dataIndex] <= index ? "black" : "#aaa",
                                                        fontWeight: currentStage[dataIndex] == index ? "bold" : "normal",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {stage.label}
                                                </p>

                                                {index < stages.length - 1 && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "10px", // Aligns with the center of the icon
                                                            left: "50%",
                                                            right: "-50%",
                                                            width: "100%",
                                                            height: "2px",
                                                            marginTop: '30px',
                                                            backgroundColor: index < currentStage[dataIndex] ? "#21A6E9" : "#B1B1B1",
                                                            zIndex: 0,
                                                        }}
                                                    >

                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    {/* Vehicle Info */}
                                    {item?.[`${currentService}Details`] && (
                                        <div className="pt-[88px]">
                                            <div className="flex md:flex-row flex-col items-center gap-[24px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className="h-[100px] w-[100px]" alt="vehicle" />
                                                <div className="grid sm:grid-cols-4 grid-cols-2 gap-[22px]">
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[18px] sm:text-[24px] text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`].reg}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.pickupLocation}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Pickup Location</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.dropLocation}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Drop Location</p>
                                                    </div>
                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[18px] sm:text-[24px]  text-[#0A0119] pb-[6px]">{item?.[`${currentService}Details`]?.systemDate.split("T")[0]}</h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Date</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* View Details button */}
                                            {!item?.[`${currentService}Details`]?.connectedVendorFully && (
                                                <div className="flex items-center gap-2">
                                                    <button className="bg-[#21A6E9] py-[10px] px-[4px] w-full text-center mt-[18px] rounded-full text-[#FFFFFF] font-satoshi font-[400] text-[18px] sm:text-[24px] leading-[33.6px]" onClick={(e) => connectCaseDetailsOnly(item)}>
                                                        View
                                                    </button>
                                                    {userId.startsWith('CC-') && (
                                                        <button className="bg-red-700 py-[10px] w-full text-center mt-[18px] rounded-full text-[#FFFFFF] font-satoshi font-[400] text-[18px] sm:text-[24px] leading-[33.6px]" onClick={() => cancleCaseProcedureFunc(item)}>
                                                            Reject
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                            {Boolean(item?.[`${currentService}Details`]?.connectedVendorFully && userId.startsWith('CC-')) && (
                                                <button className="bg-[#21A6E9] py-[10px] px-[4px] w-full text-center mt-[18px] rounded-full text-[#FFFFFF] font-satoshi font-[400] text-[18px] sm:text-[24px] leading-[33.6px]" onClick={(e) => assignedCaseViewVendor(item)}>
                                                    View Case
                                                </button>
                                            )}
                                        </div>


                                    )}

                                    {caseDetails && (
                                        <div className="fixed inset-0 bg-transparent flex items-center justify-center z-[1001]">
                                            <div className="bg-white py-[27px] h-[800px] md:px-[48px] px-[20px] rounded-[30px] shadow-lg w-[90%] overflow-y-scroll md:w-[1148px]">
                                                <div className="flex justify-between items-center">
                                                    <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000]">View Accident Details</h6>
                                                    <img onClick={() => setCaseDetails(false)} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='h-[35px] w-[35px]' alt="" />
                                                </div>

                                                <LookingForAccptance accidentData={currentItem} fromPage="quotationUpdate" />

                                            </div>
                                        </div>)}

                                    {isCancelContainerVisible && (
                                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] mt-[40px]">
                                            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                                                <h6 className="m-0 font-[700]  text-[30px] font-satoshi text-center text-[#000000]">Drop Case Procedure</h6>
                                                <img onClick={(e) => {
                                                    setIsCancelContainerVisible(false)
                                                    setReasonsForDrop(false)
                                                    setSelectedReasons([])
                                                    setOtherReason('')
                                                }}
                                                    src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='absolute top-[12px] right-[12px] h-[48px] w-[48px]' alt="" />
                                                <div>
                                                    {reasonsForDrop == false && (
                                                        <div>
                                                            <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] my-4 text-[#0A0119] pb-[6px]">We are almost there to get you perfect crane service!!! </p>
                                                            <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  my-4 pb-[6px] text-[#EE3840]">Still want to opt-out for ❓ 🤔 </p>
                                                            <div className=" grid md:grid-cols-2 grid-cols-1 pt-[40px] items-center gap-[18px] ">
                                                                <div
                                                                    // onClick={onClose}
                                                                    onClick={(e) => {
                                                                        setReasonsForDrop(false)
                                                                        setIsCancelContainerVisible(false)
                                                                        setSelectedReasons([])
                                                                        setOtherReason('')
                                                                    }}
                                                                    className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Don't Drop</button>
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                </div>
                                                                <div onClick={() => setReasonsForDrop(true)} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Drop Case</button>
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                </div>
                                                            </div>
                                                        </div>)}

                                                    {reasonsForDrop == true && (
                                                        <div>
                                                            <div>
                                                                <div>

                                                                    <div style={{ margin: "10px", marginTop: '20px', display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                        {reasons.map((reason) => (
                                                                            <button
                                                                                key={reason}
                                                                                onClick={() => handleSelectReason(reason)}
                                                                                style={{
                                                                                    fontSize: '16px',
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    padding: "15px",
                                                                                    borderRadius: "20px",
                                                                                    backgroundColor: selectedReasons.includes(reason) ? "#21A6E9" : "white",
                                                                                    color: selectedReasons.includes(reason) ? "white" : "black",

                                                                                    border: "1px solid #21A6E9",
                                                                                    cursor: "pointer",
                                                                                    boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                                                                }}
                                                                            >
                                                                                {reason}
                                                                            </button>
                                                                        ))}
                                                                    </div>


                                                                    <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                                                        <p style={{ textAlign: "left", fontSize: '16px' }}> Other Reason  : </p>
                                                                        <textarea
                                                                            style={{ margin: "10px 10px 5px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                                                    </label>

                                                                    {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                                                    <div className='pb-10'>
                                                                        {isLoading && (
                                                                            <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                                <ClipLoader color="black" loading={isLoading} />
                                                                                <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                                                            </div>
                                                                        )}
                                                                        {alreadyCancelled && (<div class="alert alert-danger" role="alert">
                                                                            You have already Cancelled Case !!!
                                                                        </div>)}
                                                                        {alertInfo.show && (
                                                                            <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                                                {alertInfo.message}
                                                                            </Alert>
                                                                        )}

                                                                        <div onClick={(e) => { cancelingOrder(currentItem) }} disabled={isLoading} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                            <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Confirm Drop Case</button>
                                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    )}

                                    {isImageContainerVisible && (
                                        <div className="fixed inset-0 bg-transparent flex items-center justify-center z-[1001]">
                                            <div className="bg-white py-[27px] h-[800px] md:px-[48px] px-[20px] rounded-[30px] shadow-lg w-[90%] overflow-y-scroll md:w-[1148px]">
                                                <div className="flex justify-between items-center">
                                                    <h6 className="m-0 font-[500] font-satoshi text-[31px] text-[#000000]">Case Details</h6>
 a                                                   <img onClick={() => setIsImageContainerVisible(false)} src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='h-[48px] w-[48px]' alt="" />
                                                </div>
                                                <div className='border rounded-xl mt-3'>
                                                    <div>
                                                        <div>
                                                            <div>
                                                                <div className='px-1 py-1 '>

                                                                    <div className='flex justify-end mb-3 pr-3 pt-2 mt-5'>
                                                                        <div className='flex items-center space-x-4 top-0'>
                                                                            <GarageIcon className='text-[#21A6E9] h-4 m-2 mt-0' />
                                                                            <p className='font-[500] font-satoshi text-[25px] text-[#000000] pb-[14px]'>{currentService} is on the way </p>
                                                                        </div>
                                                                    </div>



                                                                    <div className='flex justify-between  pt-2'>
                                                                        <div className='flex items-center space-x-4 top-0'>
                                                                            <SocialDistanceIcon className='text-[#21A6E9]  h-4 m-2 mt-0' />
                                                                            <p className='font-[500] font-satoshi text-[20px] text-[#000000] pb-[14px]'>Estimated Total Distance</p>
                                                                        </div>
                                                                        <div className=' px-3 py-1 mr-3 font-[500] font-satoshi text-[20px] text-[#000000] pb-[14px]'>
                                                                            {currentItem?.[`${currentService}Details`].distance} Km
                                                                        </div>

                                                                    </div>

                                                                    <div className='flex justify-between  pt-2'>
                                                                        <div className='flex items-center space-x-4 top-0'>
                                                                            <AssistantDirectionIcon className='text-[#21A6E9]  h-4 m-2 mt-0' />
                                                                            <p className='font-[500] font-satoshi text-[20px] text-[#000000] pb-[14px]'>Estimated Time To Drop</p>
                                                                        </div>
                                                                        <div className=' px-3 py-1 mr-3 font-[500] font-satoshi text-[20px] text-[#000000] pb-[14px]'>
                                                                            {currentItem?.[`${currentService}Details`].duration}
                                                                        </div>

                                                                    </div>


                                                                </div>
                                                                <div className='bg-white  h-full p-2'>
                                                                    <div className='bg-[#f9f9f9] rounded-xl flex justify-between m-3' style={{ border: '1px solid black' }}>
                                                                        <div className='px-4 py-3 flex-col'>
                                                                            <div className='flex'>
                                                                                <PersonIcon className='mt-1 mr-1 mb-1 h-[40px] w-[40px]' />
                                                                                <h4 className='text-xl  font-satoshi font-semibold mt-0.3'>{currentItem?.[`${currentService}Details`].reg} </h4>
                                                                            </div>
                                                                            <div className='flex gap-2'>
                                                                                <div className='flex gap-2 bg-[#21A6E9] rounded-xl p-2 mt-1'>
                                                                                    <p className='px-3 py-1 font-[500] font-satoshi text-[20px] text-[#000000] pb-[14px] '>{currentService}</p>
                                                                                    {average != 0 && (<p className='font-xs font-semibold px-2 mt-0.5'>{average}</p>)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <img className='h-20 w-20 p-2' src="https://toppng.com/uploads/preview/crane-png-indo-power-crane-11563243373unjn5iufbu.png" alt="crane" />
                                                                    </div>
                                                                    <div className='bg-white flex justify-between m-3' style={{ borderTop: '1px solid gray' }}>
                                                                        <div className='px-2 py-1 flex-col'>
                                                                            <div class='flex'>
                                                                                <MyLocationIcon className='m-1 mt-2' />
                                                                                <div className='px-2 py-2 flex-col'>
                                                                                    <h4 className='font-satoshi text-[20px] font-base'>{currentItem?.[`${currentService}Details`].pickupLocation} </h4>
                                                                                    <p className='font-satoshi text-[15px] mt-2 font-semibold'>Your pickup Location</p>
                                                                                </div>
                                                                            </div>
                                                                            <div class='flex'>
                                                                                <PinDropIcon className='m-1 mt-2' />
                                                                                <div className='px-1 py-1 flex-col'>
                                                                                    <p className='font-satoshi text-[20px] font-base'>{currentItem?.[`${currentService}Details`].dropLocation} </p>
                                                                                    <h4 className='font-satoshi text-[15px] mt-2 font-semibold'>Your Current Location </h4>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='px-2 py-4'>
                                                                            <h2 className='font-semibold font-satoshi text-[20px]'>₹ {currentItem?.[`${currentService}Details`]?.[`${currentService}WorkerOnVehicle`]?.charges}</h2>
                                                                        </div>
                                                                        {/* <img className='h-20 w-20 p-2' src="https://toppng.com/uploads/preview/crane-png-indo-power-crane-11563243373unjn5iufbu.png" alt="crane" /> */}
                                                                    </div>
                                                                    <div>
                                                                        <div className="bg-white flex justify-between items-center m-3 p-3 rounded-lg shadow-sm gap-4">

                                                                            {/* Left Actions: Accept, Proceed, Drop */}
                                                                            <div className="flex flex-col  sm:flex-row gap-3  items-center">

                                                                                {/* Accept Case Button - only if no link yet */}
                                                                                {comingLink === "" && (
                                                                                    <div
                                                                                        onClick={() => setReasonsForDrop(true)}
                                                                                        className="bg-[#21A6E9] flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer"
                                                                                    >
                                                                                        <button
                                                                                            className="font-satoshi font-[400] text-[16px] text-white"
                                                                                            onClick={(e) => getPaymentLink(currentItem)}
                                                                                        >
                                                                                            Accept Case
                                                                                        </button>
                                                                                        {/* <img src={rightarrow} alt="" className="h-[20px] w-[20px]" /> */}
                                                                                    </div>
                                                                                )}

                                                                                {/* Proceed to Payment Button - if link exists */}
                                                                                {comingLink !== "" && (
                                                                                    <div
                                                                                        onClick={getPaymentLinkPage}
                                                                                        className="shine-payment-button bg-green-700 px-4 py-2 rounded-xl cursor-pointer"
                                                                                    >
                                                                                        <p className="text-white font-semibold text-sm">Proceed to Payment</p>
                                                                                    </div>
                                                                                )}

                                                                                {/* Drop Case Button */}
                                                                                <div
                                                                                    onClick={() => cancleCaseSecondaryProcedureFunc(currentItem)}
                                                                                    className="bg-[#EE3840]  sm:mt-0 flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer"

                                                                                >
                                                                                    <button className="font-satoshi font-[400] text-[16px] text-white">
                                                                                        Drop Case
                                                                                    </button>
                                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="" className="h-[20px] w-[20px]" />
                                                                                </div>
                                                                            </div>

                                                                            {/* Call for Help */}
                                                                            <div
                                                                                onClick={() => (window.location.href = 'tel:+917800784700')}
                                                                                className="flex flex-col items-center justify-center cursor-pointer"
                                                                            >
                                                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/telephonecall.png' alt="Call for help" className="h-[24px] w-[24px] mb-1" />
                                                                                <p className="text-black font-semibold text-xs text-center">Call for Help</p>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {isCancelSecondaryContainerVisible && (
                                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001] mt-[40px]">
                                            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                                                <h6 className="m-0 font-[700]  text-[30px] font-satoshi text-center text-[#000000]">Drop Case Procedure</h6>
                                                <img onClick={(e) => {
                                                    setIsCancelSecondaryContainerVisible(false)
                                                    setReasonsSecForDrop(false)
                                                    setSelectedReasons([])
                                                    setOtherSecReason('')
                                                }}
                                                    src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='absolute top-[12px] right-[12px] h-[48px] w-[48px]' alt="" />
                                                <div>
                                                    {reasonsSecForDrop == false && (
                                                        <div>
                                                            <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] my-4 text-[#0A0119] pb-[6px]">We are almost there to get you perfect crane service!!! </p>
                                                            <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  my-4 pb-[6px] text-[#EE3840]">Still want to opt-out for ❓ 🤔 </p>
                                                            <div className=" grid md:grid-cols-2 grid-cols-1 pt-[40px] items-center gap-[18px] ">
                                                                <div
                                                                    // onClick={onClose}
                                                                    onClick={(e) => {
                                                                        setIsCancelSecondaryContainerVisible(false)
                                                                        setReasonsSecForDrop(false)
                                                                        setSelectedReasons([])
                                                                        setOtherSecReason('')
                                                                    }}
                                                                    className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Don't Drop</button>
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                </div>
                                                                <div onClick={() => setReasonsSecForDrop(true)} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Drop Case</button>
                                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                </div>
                                                            </div>
                                                        </div>)}

                                                    {reasonsSecForDrop == true && (
                                                        <div>
                                                            <div>
                                                                <div>

                                                                    <div style={{ margin: "10px", marginTop: '20px', display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                        {secReasons.map((reason) => (
                                                                            <button
                                                                                key={reason}
                                                                                onClick={() => handleSelectSecReason(reason)}
                                                                                style={{
                                                                                    fontSize: '16px',
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    padding: "15px",
                                                                                    borderRadius: "20px",
                                                                                    backgroundColor: selectedSecReasons.includes(reason) ? "#21A6E9" : "white",
                                                                                    color: selectedSecReasons.includes(reason) ? "white" : "black",

                                                                                    border: "1px solid #21A6E9",
                                                                                    cursor: "pointer",
                                                                                    boxShadow: selectedSecReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                                                                }}
                                                                            >
                                                                                {reason}
                                                                            </button>
                                                                        ))}
                                                                    </div>


                                                                    <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                                                        <p style={{ textAlign: "left", fontSize: '16px' }}> Other Reason  : </p>
                                                                        <textarea
                                                                            style={{ margin: "10px 10px 5px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                                                    </label>

                                                                    {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                                                    <div className='pb-10'>
                                                                        {isLoading && (
                                                                            <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                                <ClipLoader color="black" loading={isLoading} />
                                                                                <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                                                            </div>
                                                                        )}
                                                                        {alreadyCancelled && (<div class="alert alert-danger" role="alert">
                                                                            You have already Cancelled Case !!!
                                                                        </div>)}
                                                                        {alertInfo.show && (
                                                                            <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                                                {alertInfo.message}
                                                                            </Alert>
                                                                        )}

                                                                        <div onClick={(e) => { cancelingSecOrder(currentItem) }} disabled={isLoading} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                            <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Confirm Drop Case</button>
                                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                    {data.length === 0 && (
                        <NoDataFound />
                    )}
                </div>
            </div>
            {/* <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            /> */}
        </>
    )
}

export default QuotationUpdate;



